import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const PortOfLoading = (props: TSvgAssetProps) => (
  <SvgAsset width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.14646 4.64646C8.28038 4.51254 8.47846 4.46578 8.65813 4.52567L19.1581 8.02567C19.3908 8.10322 19.5328 8.33804 19.4936 8.5801C19.4543 8.82217 19.2452 9.00001 19 9.00001H15.5V9.76583L18.3201 12.1159C18.4341 12.2109 18.5 12.3516 18.5 12.5V16C18.5 16.2762 18.2762 16.5 18 16.5H12C11.7239 16.5 11.5 16.2762 11.5 16V12.5C11.5 12.3516 11.5659 12.2109 11.6799 12.1159L14.5 9.76583V9.00001H9.00001V19C9.00001 19.2762 8.77616 19.5 8.50001 19.5C8.22387 19.5 8.00001 19.2762 8.00001 19V9.00001H5.00001C4.79778 9.00001 4.61547 8.87819 4.53807 8.69136C4.46068 8.50452 4.50346 8.28946 4.64646 8.14646L8.14646 4.64646ZM9.00001 8.00001H15H15.9189L9.00001 5.69373V8.00001ZM8.00001 6.20712V8.00001H6.20712L8.00001 6.20712ZM15 10.6509L13.381 12H16.619L15 10.6509ZM17.5 13H12.5V15.5H17.5V13Z"
    />
  </SvgAsset>
);

export default PortOfLoading;
